import React from 'react'
import PropTypes from 'prop-types'
import ciicon from '../asset/images/CIicon.png'

function CIIcon({ bottom = '0%', right = '0%' }) {
  return (
    <button
      type="button"
      onClick={() => window.open('https://www.wavenet.com.tw/', '_blank')}
      style={{
        position: 'absolute',
        bottom,
        right,
        width: '10px',
        height: '10px',
        border: 'none',
        backgroundColor: 'transparent',
        backgroundImage: `url(${ciicon})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        cursor: 'pointer',
        zIndex: 9999,
      }}
      aria-label="Wavenet Corporate Link"
    />
  )
}

CIIcon.propTypes = {
  bottom: PropTypes.string,
  right: PropTypes.string,
}

CIIcon.defaultProps = {
  bottom: '0%',
  right: '0%',
}

export default CIIcon
